export class LoggedInUserInfo {
    token: string = "1234";
    userName: string = "vamsi";
    lanId: string = "";
    serverError: boolean = false;
    message:any;
    sessionId:any;


}